import { LifeBuoy, UserX } from 'lucide-react';
import type { LiveLessonDisplayOverlays } from '../../lib/liveLessonTypes';

function displayName(entry: { firstName: string; lastName: string }) {
  return [entry.firstName, entry.lastName].filter(Boolean).join(' ') || 'Schüler/in';
}

type LiveLessonDisplayOverlayStackProps = {
  overlays: LiveLessonDisplayOverlays | null | undefined;
};

export default function LiveLessonDisplayOverlayStack({ overlays }: LiveLessonDisplayOverlayStackProps) {
  const absences = overlays?.absences ?? [];
  const help = overlays?.help ?? [];
  if (!absences.length && !help.length) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute left-6 top-6 z-[225] flex max-w-[36vw] flex-col gap-2">
      {absences.map((entry) => (
        <div
          key={`away:${entry.studentId}`}
          className="flex items-center gap-2 rounded-xl border border-amber-400/70 bg-amber-600/30 px-4 py-2.5 text-amber-50 shadow-2xl backdrop-blur-sm"
        >
          <UserX className="h-5 w-5 shrink-0 text-amber-200" />
          <span className="text-base font-semibold md:text-lg">{displayName(entry)} ist weg</span>
        </div>
      ))}
      {help.map((entry) => (
        <div
          key={`help:${entry.studentId}`}
          className="flex items-center gap-2 rounded-xl border border-rose-400/70 bg-rose-600/30 px-4 py-2.5 text-rose-50 shadow-2xl backdrop-blur-sm"
        >
          <LifeBuoy className="h-5 w-5 shrink-0 text-rose-200" />
          <span className="text-base font-semibold md:text-lg">Support für {displayName(entry)}</span>
        </div>
      ))}
    </div>
  );
}
